export enum ApplicationType{
    NEW = "nuevo",
    RENEWAL = "renovacion",
    TRANSFER = 'transferencia'
}